/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TransferResponseDto } from './TransferResponseDto';
import {
    TransferResponseDtoFromJSON,
    TransferResponseDtoFromJSONTyped,
    TransferResponseDtoToJSON,
    TransferResponseDtoToJSONTyped,
} from './TransferResponseDto';

/**
 * 
 * @export
 * @interface TransferListResponseDto
 */
export interface TransferListResponseDto {
    /**
     * List of transfers
     * @type {Array<TransferResponseDto>}
     * @memberof TransferListResponseDto
     */
    transfers: Array<TransferResponseDto>;
    /**
     * Total number of transfers
     * @type {number}
     * @memberof TransferListResponseDto
     */
    total: number;
    /**
     * Current page number
     * @type {number}
     * @memberof TransferListResponseDto
     */
    page: number;
    /**
     * Number of items per page
     * @type {number}
     * @memberof TransferListResponseDto
     */
    limit: number;
    /**
     * Total number of pages
     * @type {number}
     * @memberof TransferListResponseDto
     */
    totalPages: number;
}

/**
 * Check if a given object implements the TransferListResponseDto interface.
 */
export function instanceOfTransferListResponseDto(value: object): value is TransferListResponseDto {
    if (!('transfers' in value) || value['transfers'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined) return false;
    return true;
}

export function TransferListResponseDtoFromJSON(json: any): TransferListResponseDto {
    return TransferListResponseDtoFromJSONTyped(json, false);
}

export function TransferListResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransferListResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'transfers': ((json['transfers'] as Array<any>).map(TransferResponseDtoFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'totalPages': json['totalPages'],
    };
}

export function TransferListResponseDtoToJSON(json: any): TransferListResponseDto {
    return TransferListResponseDtoToJSONTyped(json, false);
}

export function TransferListResponseDtoToJSONTyped(value?: TransferListResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transfers': ((value['transfers'] as Array<any>).map(TransferResponseDtoToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
        'totalPages': value['totalPages'],
    };
}

